import React from 'react';
import { CircleAlert as CircleAlertIcon, Droplets as DropletsIcon, Dumbbell as DumbbellIcon, Gauge as GaugeIcon, Sparkles as SparklesIcon } from 'lucide-react';
const changes = [{
  icon: GaugeIcon,
  title: 'Slower metabolism',
  text: 'Your body burns calories more slowly now. Refined carbs like white bread get stored as fat faster than before.'
}, {
  icon: CircleAlertIcon,
  title: 'Bloating & inflammation',
  text: 'Gluten and refined flour are common triggers for the bloating and digestive discomfort many women experience after 50.'
}, {
  icon: DropletsIcon,
  title: 'Blood sugar spikes',
  text: 'Bread raises blood sugar quickly, then crashes it — causing hunger, irritability, and fatigue just a couple hours after breakfast.'
}, {
  icon: DumbbellIcon,
  title: 'Muscle loss risk',
  text: 'After menopause, muscle loss accelerates. High-protein breakfasts help protect lean muscle and keep your body strong.'
}];
export function ScienceSection() {
  return <section className="bg-white py-20 sm:py-24" data-id="element-173" data-mp="g8ve6vbynz6v">
      <div className="mx-auto max-w-6xl px-5 lg:px-8" data-id="element-174" data-mp="bak54mthpspp">
        <div className="grid gap-8 lg:grid-cols-[1.35fr_.65fr] lg:items-start" data-id="element-175" data-mp="bb26tyyx8z50">
          <div className="max-w-2xl" data-id="element-176" data-mp="6i923b3gdqsx">
            <p className="eyebrow" data-id="element-177" data-mp="6h7gwdsq3nxh">What happens after 50</p>
            <h2 className="section-title mt-3" data-id="element-178" data-mp="2h72gt5mjcqf">
              Your body has changed. <em data-id="element-179" data-mp="3tot28ap82v20">Your breakfast should too.</em>
            </h2>
            <p className="mt-6 text-lg leading-8 text-forest/70" data-id="element-180" data-mp="3tlx34j1n20bz">
              After 50, hormonal shifts — especially the drop in estrogen —
              change how your body processes food. What worked in your 30s no
              longer works the same way. This isn't your fault. It's biology.
              And breakfast is the single most powerful meal you can change.
            </p>
          </div>

          <aside className="rounded-2xl border-l-4 border-terracotta bg-cream px-6 py-6 shadow-sm lg:mt-9" data-id="element-181" data-mp="1dx5g7abqymxz">
            <SparklesIcon size={23} className="text-terracotta" aria-hidden="true" data-id="element-182" data-mp="37g4e5zugmhdm" />
            <p className="mt-4 font-serif text-2xl leading-snug text-forest" data-id="element-183" data-mp="3c7coqz7j08sd">
              Feel steady, satisfied, and cared for — before your day begins.
            </p>
          </aside>
        </div>

        <div className="mt-12 grid gap-px overflow-hidden rounded-2xl border border-forest/10 bg-forest/10 sm:grid-cols-2" data-id="element-184" data-mp="32hkrfx81l1k7">
          {changes.map(({
          icon: Icon,
          title,
          text
        }) => <article key={title} className="bg-white p-7 sm:p-8" data-id="element-185" data-mp="3v4dtcix646vs">
              <span className="flex h-11 w-11 items-center justify-center rounded-full bg-sage/30 text-olive" data-id="element-186" data-mp="3h5xokxiv8qga">
                <Icon size={21} data-id="element-187" data-mp="3m48x94xfcuwx" />
              </span>
              <h3 className="mt-5 text-lg font-extrabold text-forest" data-id="element-188" data-mp="3m2xmgl5kamwb">
                {title}
              </h3>
              <p className="mt-2 leading-7 text-forest/70" data-id="element-189" data-mp="25sv6tz515uuj">{text}</p>
            </article>)}
        </div>
      </div>
    </section>;
}